import flatpickr from "flatpickr";
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
window.flatpickr = flatpickr

//Usage:
{/* <input type="text"
    class="form-control"
    data-toggle="flatpickr"
    asp-for="Input.{variable}"
    data-options='{}'
    flatpickr> */}

document.querySelectorAll('input[flatpickr]').forEach(function (e) {
    var elementOptions = e.dataset.options ? JSON.parse(e.dataset.options) : {};
    var defaultOptions = {
        dateFormat: elementOptions.enableTime ? "m/d/Y H:i" : "m/d/Y",
        plugins: []
    }

    if (e.classList.contains("month-select"))
    {
        defaultOptions.plugins.push(
            new monthSelectPlugin({
                shorthand: true,
                dateFormat: "m-Y",
                altFormat: "F Y",
                theme: "light"
            })
        )
    }

    var options = Object.assign(defaultOptions, elementOptions);
    CreateFlatpickr(e, options);
});

function CreateFlatpickr(e, options) {
    return new flatpickr(e, options);
}
